import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLayout } from './AppLayout';

function RedirectOpenModal({ listPath, modalKey, payload = null }) {
  const navigate = useNavigate();
  const { openFormModal } = useLayout();

  useEffect(() => {
    navigate(listPath, { replace: true });
    openFormModal(modalKey, payload);
  }, [listPath, modalKey, payload, navigate, openFormModal]);

  return null;
}

export default RedirectOpenModal;
